export  const onRemoved = (args, setFilter) => {
  const valueToRemove = args.itemData.id;

  setFilter(prevFilter => {
    return prevFilter.filter(filterItem => filterItem.params.value !== valueToRemove);
  });
};
